exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hover-3-wrapper[data-v-78d283fe]{width:250px;padding-bottom:10px}", ""]);

// exports
